import PropTypes from "prop-types";
import GeneralInfo from "../GeneralInfo";

const HistoryExpandContent = ({ global_purpose, digitalIdentity, ...infoData }) => {
  return (
    <div style={{ marginTop: 10 }}>
      <p>
        <strong>Global Purpose:</strong> {global_purpose}
      </p>
      <GeneralInfo infoData={{...infoData, global_purpose}} digitalIdentity={digitalIdentity} />
    </div>
  );
};

HistoryExpandContent.propTypes = {
  global_purpose: PropTypes.string,
  digitalIdentity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default HistoryExpandContent;
